module.exports = __webpack_public_path__ + "img/emerald.9acd68f8.png";